<template>
  <!-- 评价 -->
  <el-dialog class="dialog-evaluate" title="服务核定" :visible.sync="dialogVisible" :append-to-body="true" width="650px">
    <el-form class="g-form-grid" ref="form" :model="form" label-width="120px" :rules="rules">
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item :label="serviceType == 2 ?'讲解时长 :' : serviceType == 3 ?'活动时长 :':''" prop="serviceTime" class="g-input-right-txt">
            <el-input v-model.number="form.serviceTime" placeholder="请输入"></el-input>
            <div class="g-right-txt">小时</div>
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <el-form-item :label="serviceType == 2 ?'讲解场次 :' : serviceType == 3 ?'折合讲解场次 :':''" prop="serviceNum" class="g-input-right-txt">
            <el-input v-model.number="form.serviceNum" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <el-form-item label="星级评价 :" prop="assessStar">
            <el-rate v-model="form.assessStar" style="position:relative;top:10px;"></el-rate>
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <el-form-item label="文字评价 :" prop="assessDescribe">
            <el-input type="textarea" v-model="form.assessDescribe" placeholder></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <div slot="footer" class="footer mt-30">
      <el-button @click="cancel">取消</el-button>
      <el-button @click="fromSubmit('form')" type="primary" :loading="loadingSave">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      loadingSave: false,
      detailData: {},
      dialogVisible: false,
      form: {},
      serviceType: "",
      rules: {
        serviceTime: [
          { required: true, message: '请输入讲解时长', trigger: 'blur' },
          {
            type: 'number',
            message: '必须为数字',
            trigger: 'blur'
          }
        ],
        serviceNum: [
          { required: true, message: '请输入讲解场次', trigger: 'blur' },
          {
            type: 'number',
            message: '必须为数字',
            trigger: 'blur'
          }
        ],
        // assessStar: [
        //   { required: true, message: '请选择星级评价', trigger: 'blur' }
        // ],
        // assessDescribe: [
        //   { required: true, message: '请输入文字评价', trigger: 'blur' }
        // ]
      }
    }
  },
  methods: {
    init(data, type) {
      this.detailData = data
      this.serviceType = type
      // this.form = {
      //   serviceHour: this.detailData.serviceHour,
      //   assessStar: this.detailData.assessStar,
      //   assessDescribe: this.detailData.assessDescribe
      // }

      // this.$nextTick(() => {
      //   this.$refs['form'].clearValidate()
      // })

      this.dialogVisible = true
    },
    // 保存
    fromSubmit(form) {
      this.$refs[form].validate(vaild => {
        if (vaild) {
          this.loadingSave = true
          this.$http
            .post('/v2/bsVolunteerV2Recruit/serviceApproved', {
              ...this.form,
              id: this.detailData.id
            })
            .then(res => {
              this.loadingSave = false
              if (res.success) {
                this.$message.success('评价成功')
                this.dialogVisible = false
                this.$emit('refresh')
              } else {
                this.$message.error(res.message)
              }
            })
            .catch(() => {
              this.loadingSave = false
            })
        }
      })
    },
    // 取消
    cancel() {
      this.$refs['form'].resetFields()
      this.dialogVisible = false
    }
  }
}
</script>

<style lang="scss" scoped>
</style>